import styled from "styled-components";
import { Button } from "@vds/buttons";
import { Modal, ModalBody } from "@vds/modals";
import { Text } from '@vds/core';


export const ProductBoxWrapMonarch = styled.div`

width:384px;
height:384px;
border-radius: 0.5rem;
 background-image: ${({ url }) => `url("${url}")`};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  aspect-ratio:1/1;
@media only screen and (max-width: 767px) {
width:328px;
height:328px;
}
`

export const ProductBoxWrap = styled.div`
  margin-top: 10px;
  background-image: ${({ url }) => `url("${url}")`};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  padding: 16px !important;
  ${(props) =>
    props?.isEnableVBC && props?.isEligibleVBC
      ? `min-height: 285px;`
      : `min-height: 542px;`}
  max-width: 290px;
  @media only screen and (min-width: 601px) and (max-width: 954px) {
   max-width: 222px;
   margin-top: 8px !important;
  }
  ${(props) =>
    props.isEnableVBC && props.isEligibleVBC
      ? `height: 30%;`
      : `height: 95%;`}
  left: 0px;
  ${(props) =>
    props.isEnableVBC && props.isEligibleVBC
      ? props?.isMobile
        ? `top: 0px;`
        : `top: 0px;`
      : `top: 0px;`}
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  transition-duration: 0.2s;
  @media screen and (min-device-width: 768px) {
    :hover {
      transform: scale(1.02);
    }
  }
  @media screen and (min-device-width: 320px) and ${(props) =>
      props?.isEnableVBC && props?.isEligibleVBC
        ? `(max-device-width: 290px)`
        : `(max-device-width: 767px)`} {
    // background-size: cover;
    ${(props) =>
      props?.isEnableVBC && props?.isEligibleVBC
        ? `height: 30%;`
        : `height: 98.5%;`}
  }
  @media (min-width: 320px) and (max-width: 430px) {
    ${(props) =>
      props.isEnableVBC && props.isEligibleVBC === true
        ? `margin-top: 0;`
        : `margin-top: 10px;`}
  }
`;

export const ProductBoxWrapVBC = styled.div`
  margin-top: 0px !important;
  //background-image: ${({ url }) => `url("${url}")`};
  background-color:#E10014;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  padding: 16px !important;
  ${(props) =>
    props?.isEnableVBC && props?.isEligibleVBC
      ? `min-height: 265px;`
      : `min-height: 542px;`}
  max-width: 290px;
  @media only screen and (min-width: 601px) and (max-width: 954px) {
   max-width: 222px;
  }
  @media only screen and (max-width: 545px) {
   ${(props) =>
    props?.isEnableVBC && props?.isEligibleVBC
      ? `min-height: 290px;` 
      : `min-height: 542px;`}
   max-width: 290px; 
  }
  ${(props) =>
    props.isEnableVBC && props.isEligibleVBC
      ? `height: 30%;`
      : `height: 95%;`}
  left: 0px;
  ${(props) =>
    props.isEnableVBC && props.isEligibleVBC
      ? props?.isMobile
        ? `top: 10px;`
        : `top: 0px;`
      : `top: 0px;`}
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  transition-duration: 0.2s;
  @media screen and (min-device-width: 768px) {
    :hover {
      transform: scale(1.02);
    }
  }
  @media screen and (min-device-width: 320px) and ${(props) =>
      props?.isEnableVBC && props?.isEligibleVBC
        ? `(max-device-width: 290px)`
        : `(max-device-width: 767px)`} {
    // background-size: cover;
    ${(props) =>
      props?.isEnableVBC && props?.isEligibleVBC
        ? `height: 30%;`
        : `height: 98.5%;`}
  }
  @media (min-width: 320px) and (max-width: 430px) {
    ${(props) =>
      props.isEnableVBC && props.isEligibleVBC === true
        ? `margin-top: 0;`
        : `margin-top: 10px;`}
  }
`;

export const LaptopProductBoxWrap = styled.div`
  margin-top: 0px;
  background-image: ${({ url }) => `url("${url}")`};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  ${(props) =>
    props?.isEnableVBC && props?.isEligibleVBC
      ? `min-height: 265px;`
      : `min-height: 542px;`}
  max-width: 290px;
  ${(props) =>
    props?.isEnableVBC && props?.isEligibleVBC
      ? `height: 30%;`
      : `height: 95%;`}
  left: 0px;
  top: 0px;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  transition-duration: 0.2s;
  @media screen and (min-device-width: 768px) {
    :hover {
      transform: scale(1.02);
    }
  }
  @media screen and (min-device-width: 320px) and ${(props) =>
      props?.isEnableVBC && props?.isEligibleVBC
        ? `(max-device-width: 290px)`
        : `(max-device-width: 767px)`} {
    background-size: cover;
    height: 98.5%;
  }
`;

export const TextOnImageWrapper = styled.div`
  position: absolute;
  left: 20px;
  right: 20px;
  ${(props) =>
    props?.isEnableVBC && props?.isEligibleVBC === true
      ? `top:5%;`
      : props?.isEnableVBC & !props?.isEligibleVBC || props.enableVBCStyle
      ? `top:20%;`
      : props?.popularDevice
      ? "top:50%;"
      : `top:40%;`}
  @media (max-width: 768px) {
    bottom: 30%;
  }
  @media (max-width: 420px) {
    left: 8px;
    right: 8px;
  }
  p {
    margin: 12px 0px;
  }
`;

export const TextOnImage = styled(Text)`
  display: flex;
`;

export const SubtextOnImage = styled(Text)`
  display: flex;
  letter-spacing: 0.5px;
`;

export const LinkTextOnImage = styled.div`
  display: flex;
  align-items: center;
  display: flex;
  font-weight: 700;
  color: #ffffff;
  padding-top: ${({ isBYOD }) => (isBYOD ? "38px" : "0px")};

  @media (max-width: 545px) {
   padding-top: ${({ isBYOD }) => (isBYOD ? "53px" : "0px")};
  }

  @media (min-width: 546px) and (max-width: 954px) {
   padding-top: ${({ isBYOD }) => (isBYOD ? "59px" : "0px")};
  }
  * {
    stroke: aliceblue !important;
  }
  & > a {
    padding-left: 0px;
  }
  @media (max-width: 420px) {
    margin-top: 4px;
  }
`;

export const LinkButton = styled(Button)`
  color: #fbf7f7 !important;
  border: #ffffff solid 1px !important;
  height: 32px;
  font-size: small;
`;
export const LinkButtonVBC = styled(Button)`
  color: #fbf7f7 !important;
  border: #ffffff solid 1px !important;
  height: 32px;
  font-size: small;
  background-color: #E1001400 !important;
`;
export const DeviceContainer = styled.div`
  cursor: pointer;
  width: 100%;
  min-height: 542px;
  min-width: 290px;
  height: 100%;
  left: 0px;
  top: 0px;
  color: #000;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  position: relative;
  @media only screen and (max-width: 545px) {
    min-width: 158px;
  }
  @media screen and (min-width: 601px) and (max-width: 954px) {
    & {
      min-width: 219px !important;
    }
  }
  @media only screen and (min-width: 990px) and (max-width: 1100px) {
    min-width: 240px;
  }
  @media only screen and (min-width: 1100px) and (max-width: 1200px) {
    min-width: 260px;
  }
  :hover {
    cursor: pointer;
  }
`;

export const DetailsModal = styled(Modal)`
  padding: 1.25rem;
  width: 560px;
  height: 596px;
  min-height: auto;
  outline: none !important;
  [class^="ChildWrapper-VDS"] {
    height: 98% !important;
  }
  @media only screen and (min-width: 768px) {
    padding: 4rem 2rem;
    > div:first-child {
      overflow: hidden;
      margin-right: 1.5rem;
    }
  }
  > div:first-child {
    overflow: hidden;
  }
  > div {
    padding: 0px !important;

    @media only screen and (max-width: 420px) {
      overflow: auto;
      ::-webkit-scrollbar {
        width: 4px;
        height: 20px;
        background: #d8dada;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: #6f7171;
        border-radius: 10px;
      }
    }
    iframe {
      min-height: 250px !important;
      width: 100%;
      border: none !important;

      @media only screen and (max-width: 420px) {
        overflow: auto;
        ::-webkit-scrollbar {
          width: 4px;
          height: 20px;
          background: #d8dada;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
          background: #6f7171;
          border-radius: 10px;
        }
      }
    }
    > span {
      height: 100%;
      width: 100%;

      & > div {
        height: 100% !important;

        & > div {
          padding-right: 20px !important;
        }
      }
    }
  }
  @media only screen and (max-width: 767px) {
    position: absolute;
    height: 100vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 95vw;
    > div:first-child {
      margin-top: 3rem !important;
    }
    [data-testid="modal-body"] {
      margin-top: 2.5rem !important;
    }
  }
  @media only screen and (max-width: 420px) {
    width: 100vw;
  }
`;

export const DetailsModalBody = styled(ModalBody)`
  padding: 0;
  outline: none !important;
  height: 100%;
`;
